const validate = values => {
  const errors = {}

  if (values && values.list_form?.listItems) {
    values.list_form.listItems.forEach((list, index) => {
      if (!list.line1 || list.line1.trim().length === 0) {
        errors.list_form = {
          ...errors?.list_form,
          listItems: {
            ...errors.list_form?.listItems,
            [`${index}`]: {
              ...errors.list_form?.listItems[`${index}`],
              line1: "This line is required",
            },
          },
        }
      }

      if (list.listItemButtons)
        list.listItemButtons.forEach((button, buttonIndex) => {
          if (button.name && button.name.trim().length > 0) {
            if (!button.link || button.link.trim().length === 0) {
              errors.list_form = {
                ...errors?.list_form,
                listItems: {
                  ...errors.list_form?.listItems,
                  [`${index}`]: {
                    ...errors.list_form?.listItems[`${index}`],
                    listItemButtons: {
                      ...errors.list_form?.listItems[`${index}`]
                        ?.listItemButtons,
                      [`${buttonIndex}`]: {
                        link: "Link is required",
                      },
                    },
                  },
                },
              }
            } else if (
              !(
                /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(button.link) ||
                /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(
                  button.link
                ) ||
                /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(
                  button.link
                )
              )
            ) {
              errors.list_form = {
                ...errors?.list_form,
                listItems: {
                  ...errors.list_form?.listItems,
                  [`${index}`]: {
                    ...errors.list_form?.listItems[`${index}`],
                    listItemButtons: {
                      ...errors.list_form?.listItems[`${index}`]
                        ?.listItemButtons,
                      [`${buttonIndex}`]: {
                        link: "Link should be an URL(include http:// or https://), a phone number or an email",
                      },
                    },
                  },
                },
              }
            }
          }
          if (button.link && button.link.trim().length > 0) {
            if (!button.name || button.name.trim().length === 0) {
              errors.list_form = {
                ...errors?.list_form,
                listItems: {
                  ...errors.list_form?.listItems,
                  [`${index}`]: {
                    ...errors.list_form?.listItems[`${index}`],
                    listItemButtons: {
                      ...errors.list_form?.listItems[`${index}`]
                        ?.listItemButtons,
                      [`${buttonIndex}`]: {
                        name: "Name is required",
                      },
                    },
                  },
                },
              }
            }
            if (
              !(
                /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(button.link) ||
                /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(
                  button.link
                ) ||
                /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(
                  button.link
                )
              )
            ) {
              errors.list_form = {
                ...errors?.list_form,
                listItems: {
                  ...errors.list_form?.listItems,
                  [`${index}`]: {
                    ...errors.list_form?.listItems[`${index}`],
                    listItemButtons: {
                      ...errors.list_form?.listItems[`${index}`]
                        ?.listItemButtons,
                      [`${buttonIndex}`]: {
                        link: "Link should be an URL(include http:// or https://), a phone number or an email",
                      },
                    },
                  },
                },
              }
            }
          }
        })
    })
  }

  if (!values.list_form?.experience) {
    errors.list_form = {
      ...errors?.list_form,
      experience: "The experience name is required!",
    }
  }

  if (!values.list_form?.list) {
    errors.list_form = {
      ...errors?.list_form,
      list: "The list is required!",
    }
  }

  return errors
}

export default validate
